import { render, staticRenderFns } from "./StudyResultSummary.vue?vue&type=template&id=e4e0d6a2&lang=pug"
import script from "./StudyResultSummary.vue?vue&type=script&lang=ts"
export * from "./StudyResultSummary.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports